import React from 'react';
import { connect } from 'react-redux';
import { getUsers, signup, deleteUsers, USERS, SIGNUP } from './UsersActions';
import {reset} from '../../lib/Utils';
import Users from '../../views/Users';
import toast from 'react-toastify';
class UsersContainer extends React.Component {

    constructor(props) {
        super(props);

        this.onSubmit = this
            .onSubmit
            .bind(this);
        this.removeUsers = this
            .removeUsers
            .bind(this);
        this.state = {
            showError: true
        };

        this.closeError = this
            .closeError
            .bind(this);
    }

    componentDidMount() {
        let { dispatchGetUsers } = this.props;
        dispatchGetUsers();
    }

    onSubmit(data) {
        data.roles = ["USER"];
        /*
        this
            .props
            .dispatch(signup(data));
            */

        let { dispatchSignup, dispatchGetUsers} = this.props;
        dispatchSignup(data, (err, result) =>{
          if(err){
            toast.error(err.message);
          }else{
            toast.success("Successfully removed user!");
            dispatchGetUsers();
          }
        });

    }

    closeError() {
        this.setState({ showError: false });
    }

    removeUsers(ids) {
        let { dispatchDeleteUsers, dispatchGetUsers } = this.props;
        dispatchDeleteUsers(ids, (err, result) =>{
          if(err){
            toast.error(err.message);
          }else{
            toast.success("Successfully removed user!");
            dispatchGetUsers();
          }
        });
    }

    render() {

        let { users,dispatchSignup, dispatchGetUsers, signupState, dispatchResetSignup, dispatchResetUsers, dispatchDeleteUsers} = this.props;
        return <Users 
        dispatchDeleteUsers={dispatchDeleteUsers}
        dispatchResetUsers={dispatchResetUsers} 
        dispatchResetSignup={dispatchResetSignup} 
        dispatchSignup={dispatchSignup} 
        dispatchGetUsers={dispatchGetUsers}
        users={users} 
        signupState={signupState}/>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchGetUsers: () => dispatch(getUsers()),
        dispatchDeleteUsers : (ids, cb) => dispatch(deleteUsers(ids, cb)),
        dispatchSignup: (user, cb) => dispatch(signup(user, cb)),
        dispatchResetSignup: () => dispatch(reset(SIGNUP)),
        dispatchResetUsers: () => dispatch(reset(USERS))
    };
};

const mapStateToProps = (state) => ({ users: state.users, signupState: state.signup });

export default connect(mapStateToProps, mapDispatchToProps)(UsersContainer);


// WEBPACK FOOTER //
// ./src/containers/Users/UsersContainer.js